module.exports = __webpack_public_path__ + "media/31.a6235f68.mp3";